import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://test-sso.isgplatform.com/",
  realm: "isg-platform",
  clientId: "isg-react-service"
});

export default keycloak;